export default class Meeting {
  patternId: string;
  targetDate: string;
  affiliationId: string;
  userIncode: string;
  startTime: string;
  endTime: string;
  breakTime: string;
  midnightBreakTime: string;
  enkachiTeate: number;
  bikou: string;
  dayWork: string;
  reserveid1: string;
  constructor(
    patternId = "",
    targetDate = "",
    affiliationId = "",
    userIncode = "",
    startTime = "",
    endTime = "",
    breakTime = "",
    midnightBreakTime = "",
    enkachiTeate = 0,
    bikou = "",
    dayWork = "",
    reserveid1 = ""
  ) {
    this.patternId = patternId;
    this.targetDate = targetDate;
    this.affiliationId = affiliationId;
    this.userIncode = userIncode;
    this.startTime = startTime;
    this.endTime = endTime;
    this.breakTime = breakTime;
    this.midnightBreakTime = midnightBreakTime;
    this.enkachiTeate = enkachiTeate;
    this.bikou = bikou;
    this.dayWork = dayWork;
    this.reserveid1 = reserveid1;
  }
}
